(() => {
  if (customElements.get('gn-research-modal-v29')) return;

  class GNResearchModalV29 extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-research-open]');
      if (!this.dialog || !this.trigger || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger.hidden = false;
      this.trigger.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.classList.add('gn-research-open-v29');
        const content = this.dialog.querySelector('.gn-research-dialog-v29__content');
        if (content) content.scrollTop = 0;
      }, options);
      this.querySelector('[data-research-close]')?.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('pointerdown', (event) => {
        this.backdropPointer = event.target === this.dialog && this.isOutside(event);
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (this.backdropPointer && event.target === this.dialog && this.isOutside(event)) this.dialog.close();
        this.backdropPointer = false;
      }, options);
      this.dialog.addEventListener('close', () => this.afterClose(), options);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || !this.dialog.open) return;
        const focusable = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
          .filter((element) => element.tabIndex >= 0 && !element.closest('[hidden], [inert]') && element.getClientRects().length > 0);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!first) return;
        const active = document.activeElement;
        if (event.shiftKey && (active === first || active === this.dialog || !this.dialog.contains(active))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (active === last || active === this.dialog || !this.dialog.contains(active))) {
          event.preventDefault();
          first.focus();
        }
      }, options);
    }

    isOutside(event) {
      const box = this.dialog.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
    }

    afterClose() {
      if (!document.querySelector('.gn-research-dialog-v29[open]')) document.documentElement.classList.remove('gn-research-open-v29');
      if (this.trigger?.isConnected && !document.querySelector('dialog[open]')) this.trigger.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
      this.afterClose();
    }
  }

  customElements.define('gn-research-modal-v29', GNResearchModalV29);
})();
